export default arr => arr[arr.length - 1]



// WEBPACK FOOTER //
// ./src/utils/array-last.js